import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Costs } from '@/modules/cash/views/CostsV2';
import CostsLegacy from '../Costs/Costs.vue';

import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'CostsControllerView',
  setup(__props) {

const isNewFeesChargeEnbaled = computed(() => {
  return FeatureFlagsModule.isEnabled(FeatureFlags.ENABLE_NEW_FEES_CHARGE);
});

return { __sfc: true,isNewFeesChargeEnbaled, Costs, CostsLegacy }
}

})